import { render, staticRenderFns } from "./ProductOtherConfig.vue?vue&type=template&id=e7a4c5e8&scoped=true&"
import script from "./ProductOtherConfig.vue?vue&type=script&lang=js&"
export * from "./ProductOtherConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a4c5e8",
  null
  
)

export default component.exports